import { theme } from '@/theme';

export const styles = {
  footerWrapper: {
    background: theme.colors.surface,
    borderTop: `1px solid ${theme.colors.border}`,
    color: theme.colors.text.muted,
    padding: '64px 32px 32px',
    fontFamily: theme.typography.fontFamily,
  },

  gridContainer: {
    maxWidth: '1280px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '40px',
    marginBottom: theme.spacing.giant,
  },

  brandHeading: {
    color: theme.colors.text.heading,
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.bold,
    margin: '0 0 16px',
  },

  brandHighlight: {
    color: theme.colors.primary,
  },

  brandDescription: {
    fontSize: theme.typography.fontSize.xs,
    lineHeight: theme.typography.lineHeight.relaxed,
  },

  columnHeading: {
    color: theme.colors.text.heading,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.semibold,
    margin: '0 0 16px',
  },

  linkList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '10px',
    fontSize: theme.typography.fontSize.xs,
  },

  listLinkItem: {
    color: theme.colors.text.body,
    textDecoration: 'none',
  },

  contactGroup: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: theme.spacing.md,
    fontSize: theme.typography.fontSize.xs,
  },

  contactItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm,
  },

  contactIcon: {
    color: theme.colors.primary,
    flexShrink: 0,
  },

  bottomBar: {
    maxWidth: '1280px',
    margin: '0 auto',
    paddingTop: theme.spacing.xxl,
    borderTop: `1px solid ${theme.colors.border}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '11px',
    color: theme.colors.text.muted,
  },

  bottomLinks: {
    display: 'flex',
    gap: '20px',
  },

  clickableSpan: {
    cursor: 'pointer',
  },
} as const;
